<template>
    <span class="licence-number LicenceRenderer d-flex">
        <span class="licence-symbol">
            <i class="fa fa-hashtag"></i>
        </span>
        <span class="licence-text">{{ this.licenceNumber }}</span>
    </span>
</template>
  
<script>
import Utils from "@/services/utils.js";

export default {
    name: "LicenceRenderer",
    props: ["object", "columnKey"],
    computed: {
        licenceNumber: function () {
            return Utils.pad(this.object[this.columnKey], '0', 8);
        }
    }
};
</script>
  